/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// BODYCOPY
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	bodycopy: {
		margin: '0 auto',
		textAlign: 'center',
		'& p': {
			fontSize: pxToEm(14),
			lineHeight: '1.4',
			marginBottom: pxToEm(25)
		}
	}
};